import { render, staticRenderFns } from "./TableCustom.vue?vue&type=template&id=082bfcf0&scoped=true&"
import script from "./TableCustom.vue?vue&type=script&lang=ts&"
export * from "./TableCustom.vue?vue&type=script&lang=ts&"
import style0 from "./TableCustom.vue?vue&type=style&index=0&id=082bfcf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082bfcf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082bfcf0')) {
      api.createRecord('082bfcf0', component.options)
    } else {
      api.reload('082bfcf0', component.options)
    }
    module.hot.accept("./TableCustom.vue?vue&type=template&id=082bfcf0&scoped=true&", function () {
      api.rerender('082bfcf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/table/TableCustom.vue"
export default component.exports